import { useState } from "react";

/**
 * Adressen skolan lägger in som mottagare i Meitner.
 *
 * Står överst under Utskick därför att det är det första skolan behöver göra —
 * utan adressen i Meitner kommer inga utskick alls, och resten av fliken är
 * tom av ett skäl ingen kan se.
 *
 * **Adressen bär skolans token** (planens tillägg 2: skolbindningen vilar på
 * att den inte går att gissa). Den visas därför bara för den som redan är
 * inloggad som skoladmin, och texten säger att den inte ska spridas vidare.
 */
export default function InboundAddress({ data }) {
  const [copied, setCopied] = useState(false);
  if (!data) return null;

  async function copy() {
    try {
      await navigator.clipboard.writeText(data.address);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Utan urklippsrättighet markerar vi texten i stället — adressen står
      // ändå på skärmen, och en knapp som inte gör något är värre än ingen.
      setCopied(false);
    }
  }

  if (!data.ready) {
    return (
      <section className="card">
        <h2>Adress för utskick</h2>
        <p className="hint">
          Adressen är inte klar än. Vi säger till när den finns — lägg inte in
          någon adress i Meitner innan dess, för då studsar utskicken.
        </p>
      </section>
    );
  }

  return (
    <section className="card">
      <h2>Adress för utskick</h2>
      <p className="hint">
        Lägg in den här adressen som mottagare på utskick i Meitner. Lägg den
        <strong> bara på utskick som går till hela skolan</strong> — inte på
        klasslistor, mentorsgrupper eller utskick till vårdnadshavare.
      </p>
      <div className="address">
        <code>{data.address}</code>
        <button className="secondary" onClick={copy}>
          {copied ? "Kopierad" : "Kopiera"}
        </button>
      </div>
      <p className="hint">
        Adressen är personlig för skolan och ska inte spridas vidare. Hör av er
        om den behöver bytas, eller om ni misstänker att den kommit på avvägar.
      </p>
    </section>
  );
}
